import PropTypes from 'prop-types';
import Footer from '../components/Layout/Footer';
import Header from '../components/Layout/Header';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { initializeApp } from '../reducers/initializeAppActionsCreator';
import { parseJwt } from '../services/jwtParser';
import ScrollToTop from '../components/Utils/ScrollToTop';
import { Component } from 'react';

class FrontendUserLayout extends Component {
  componentDidMount() {
    window.addEventListener('storage', (e) => {
      if (e.key === 'authToken' && e.newValue && parseJwt(e.newValue)?.username !== this.props.authReducer.username) {
        window.location.reload();
      }
    });
    this.props.dispatch(initializeApp());
  }
  render() {
    const shiftClass = this.props.selectedRowsReducer?.selectedItems?.length > 0 ? 'shifted' : '';
    return (
      <div id='page-wrapper' className='restricted-page-wrapper'>
        <Header />
        <main className='content'>
          <div className={`${this.props.isWide ? 'section-wide' : 'section'}`}>
            {this.props.children}
            <div className={`back-to-top-wrapper ${shiftClass} ${!isMobile ? 'desktop' : ''}`}>
              <ScrollToTop />
            </div>
          </div>
        </main>
        <Footer isWide={this.props.isWide} />
      </div>
    );
  }
}

FrontendUserLayout.propTypes = {
  isWide: PropTypes.bool,
};

FrontendUserLayout.defaultProps = {
  isWide: false,
};

export default connect((state) => state)(FrontendUserLayout);
